import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { DemandTopicsListItem } from '../models/demand-topics-list-item';

export class DemandsTopicsApi {
    constructor(protected baseUrl: string) {}

    public cget = (
        customerAccountId: number,
        searchParams?: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<DemandTopicsListItem>>> => {
        const params = new URLSearchParams(searchParams);
        params?.set('customerAccountId', customerAccountId.toString());
        return safeRequest(
            () => request.get(`${this.baseUrl}/topics`, { params }),
            response => response.data
        );
    };

    public assignContacts = (topicId: number, contactIds: number[]): Promise<ApiResult<void>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/topics/${topicId}/assign-contacts`, { contactIds }),
            response => response.data
        );
    };

    public changeInterest = (topicId: number, interested: boolean): Promise<ApiResult<void>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/topics/${topicId}/change-interest`, { interested }),
            response => response.data
        );
    };
}
